<template>
  <vs-collapse-transition>
    <div v-if="modelValue" :class="alertClasses" :style="alertStyles">
      <div v-if="$slots.icon" :class="ns.e('icon')">
        <slot name="icon" />
      </div>

      <div
        v-if="$slots.title"
        :class="[
          ns.e('title'),
          isBoolean(modelValue) && ns.em('title', 'click__hidden'),
        ]"
        @click="handleClickHidden"
      >
        <slot name="title" />
        <!-- <icon-plus
          v-if="!closable && typeof hiddenContent === 'boolean'" 
          :less="!hiddenContent"
          @click.stop="handleClickHidden" 
        /> -->
      </div>
      <vs-collapse-transition>
        <div v-if="!hiddenContent" :class="ns.e('content')">
          <div :class="ns.e('content__text')">
            <slot />
            <slot :name="`page-${page}`" />
          </div>
        </div>
      </vs-collapse-transition>

      <button v-if="closable" :class="ns.e('close')" @click="handleClickClose">
        <icon-close hover="less" />
      </button>

      <div v-if="$slots.footer" :class="ns.e('footer')">
        <slot name="footer" />
      </div>

      <div v-if="!!progress" :class="ns.e('progress')">
        <div
          :class="ns.e('progress__bar')"
          :style="{ width: `${progress}%` }"
        />
      </div>

      <div v-if="getTotalPages > 0" :class="ns.e('pagination')">
        <button @click="handleClickPrevPage" v-text="'<'" />
        <span>{{ page }} / {{ getTotalPages }}</span>
        <button @click="handleClickNextPage" v-text="'>'" />
      </div>
    </div>
  </vs-collapse-transition>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue'
import { isBoolean } from 'lodash-unified'
import { getVsColor, useBaseClasses } from '@vuesax-plus/utils'
import { IconClose, VsCollapseTransition } from '@vuesax-plus/components'
import { useNamespace } from '@vuesax-plus/hooks'
import { UPDATE_MODEL_EVENT } from '@vuesax-plus/constants'
import { alertEmits, alertProps } from './alert'
import type { CSSProperties } from 'vue'

defineOptions({
  name: 'VsAlert',
})

const props = defineProps(alertProps)
const slots = useSlots()
const emit = defineEmits(alertEmits)

const ns = useNamespace('alert')

const alertClasses = computed(() => [
  ...useBaseClasses(props).value,
  ns.b(),
  props.solid && ns.m('solid'),
  props.border && ns.m('border'),
  props.shadow && ns.m('shadow'),
  props.gradient && ns.m('gradient'),
  props.flat && ns.m('flat'),
  props.relief && ns.m('relief'),
  getPages.value.length > 0 && ns.m('pages'),
])
const alertStyles = computed(() => {
  return ns.cssVar({
    '--vs-color': props.color && getVsColor(`${props.color}`),
  }) as CSSProperties
})

const getTotalPages = computed(() => {
  const keys = Object.keys(slots).filter((item) => {
    return item.includes('page')
  })
  return keys.length
})

const getPages = computed(() => {
  const keys = Object.keys(slots).filter((item) => {
    return item.includes('page')
  })

  const values: any = []
  keys.forEach((item) => {
    values.push(`${props.page}` === item.split('-')[1] && slots[item])
  })
  return values
})

const handleClickClose = () => {
  emit(UPDATE_MODEL_EVENT, !props.modelValue)
}
const handleClickHidden = () => {
  emit('update:hiddenContent', !props.hiddenContent)
}
const handleClickPrevPage = () => {
  if (props.page > 1) {
    emit('update:page', props.page - 1)
  }
}
const handleClickNextPage = () => {
  if (props.page < getTotalPages.value) {
    emit('update:page', props.page + 1)
  }
}
</script>
